const releases = [
  {
    title: "צלילי אהבה",
    artist: "Sighdafekt",
    cover: "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/ee/69/da/ee69da1b-efdb-785d-2146-e7bf9f33a249/cover.jpg/600x600bb.jpg",
    link: "https://sigh.ffm.to/lovesounds"
  },
  {
    title: "ילדה רעה",
    artist: "Guyku, Sighdafekt",
    cover: "https://is1-ssl.mzstatic.com/image/thumb/Music211/v4/7b/f4/61/7bf461e9-1c2d-83d7-182f-5798acb9f28a/cover.jpg/600x600bb.jpg",
    link: "https://ffm.to/yaldaraa"
  },
  {
    title: "העולם מסתובב",
    artist: "Ethel",
    cover: "https://i.imgur.com/WFpm26n.jpeg",
    link: "https://ethel.link/haolammistovev"
  }
];

export default releases;
